import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.showBlock
    ? _c(
        "div",
        {
          staticClass: "reviews-bottom d-flex align-center justify-center",
          class: _setup.isMobile ? "flex-column" : "ga-4",
          attrs: { "data-qa": "lpu_reviews_bottom" },
        },
        [
          _setup.redirectHref
            ? _c(
                VBtn,
                {
                  staticClass:
                    "reviews-bottom__btn branding-btn rounded-20 text-subtitle-1 text-none",
                  class: _setup.isMobile
                    ? "branding-btn--primary w-100"
                    : "branding-btn--background",
                  attrs: {
                    depressed: "",
                    height: "52",
                    href: _setup.redirectHref,
                    block: _setup.isMobile,
                    "data-qa": "show_more_list_item",
                    "data-reviews-list-yandex-goals":
                      "reviews_list_click_show_more_reviews_redirect",
                  },
                },
                [_vm._v("\n    " + _vm._s(_setup.showMoreLabel) + "\n  ")]
              )
            : _setup.showExpandButton
            ? _c(
                VBtn,
                {
                  staticClass:
                    "reviews-bottom__btn branding-btn rounded-20 text-subtitle-1 text-none",
                  class: _setup.isMobile
                    ? "branding-btn--primary w-100"
                    : "branding-btn--background",
                  attrs: {
                    depressed: "",
                    height: "52",
                    block: _setup.isMobile,
                    "data-qa": "show_more_list_item",
                    "data-reviews-list-yandex-goals":
                      "reviews_list_click_show_more_reviews_lpu_page",
                  },
                  on: {
                    click: function ($event) {
                      return _setup.emit("expand")
                    },
                  },
                },
                [_vm._v("\n    " + _vm._s(_setup.showMoreLabel) + "\n  ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _setup.showLeaveButton
            ? _c(_setup.ReviewsLeaveBtn, { attrs: { "lpu-id": _vm.lpuId } })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }